import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  content: string;
  profileImage?: string;
}
export const TestimonialCard = ({
  name,
  content,
  profileImage
}: TestimonialCardProps) => {
  return <div className="bg-gray-100 p-4 rounded-lg" data-id="element-275">
      <div className="flex items-center mb-3" data-id="element-276">
        {profileImage && <div className="w-12 h-12 rounded-full overflow-hidden mr-3 border-2 border-white shadow-sm" data-id="element-277">
            {profileImage.includes('PLACEHOLDER') ? <div className="w-full h-full bg-gray-300 flex items-center justify-center text-xs text-gray-500" data-id="element-278">
                {/* PLACEHOLDER: Headshot of woman in her late 40s-50s, confident and healthy-looking */}
                Photo
              </div> : <img src={profileImage} alt={`Profile photo of ${name}`} className="w-full h-full object-cover" data-id="element-279" />}
          </div>}
        <div data-id="element-280">
          <p className="font-bold" data-id="element-281">{name}</p>
          <div className="flex" data-id="element-282">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-500 fill-yellow-500" size={14} data-id="element-283" />)}
          </div>
        </div>
      </div>
      <p className="whitespace-pre-line" data-id="element-284">{content}</p>
    </div>;
};